import { isNaN } from 'formik';
import React, { useEffect } from 'react';
import { Params, useLocation, useParams } from 'react-router';

import { useFleet } from 'commons/hooks';

import { useEventing } from './useEventing';

const resolveParameterProps = (primaryId: string | undefined, params: Params) => {
  if (!primaryId || (!params[primaryId] && !params.id)) {
    return {};
  }
  const resolvedId = params[primaryId] || params.id;
  const parseId = () => {
    const parsed = parseInt(`${resolvedId}`, 10);
    if (!isNaN(parsed)) {
      return parsed;
    }
    return resolvedId;
  };
  return { [primaryId]: parseId() };
};

interface TrackingRouteProps {
  pageName?: string;
  properties?: any;
  // name of the primary id we want to access
  primaryId?: string;
  children: React.ReactNode;
}

export const TrackingRoute: React.FC<TrackingRouteProps> = ({
  pageName,
  primaryId,
  children,
  properties,
}: TrackingRouteProps) => {
  const eventing = useEventing();
  const { name } = useFleet();
  const params = useParams();
  const location = useLocation();
  useEffect(() => {
    eventing.page(`${name}.${pageName}`, {
      ...(properties || {}),
      ...resolveParameterProps(primaryId, params),
    });
  }, [location.pathname + location.search]);

  return <>{children}</>;
};
